/**
 * Copyright (C) 2021 - 2026 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { AdministratorService } from '../administrator/administrator.service';
import { ConstantService } from '../constant/constant.service';
import { HttpService } from '../http/http.service';
import { SessionStorageService } from '../storage/session-storage/session-storage.service';
import { StorageService } from '../storage/storage.service';
import { AuthService } from './auth.service';

@NgModule({
	providers: [
		{
			provide: AuthService,
			useFactory: (
				config: IAppConfig,
				storageService: StorageService,
				sessionStorageService: SessionStorageService,
				httpService: HttpService,
				administrationService: AdministratorService,
				constantService: ConstantService,
				router: Router,
			) =>
				new AuthService(
					config,
					storageService,
					sessionStorageService,
					httpService,
					administrationService,
					constantService,
					router,
				),
			deps: [
				APP_CONFIG,
				StorageService,
				SessionStorageService,
				HttpService,
				AdministratorService,
				ConstantService,
				Router,
			],
		},
	],
})
export class AuthModule {}
